var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadar = function SvgRadar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 124
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "radar_svg__a",
    x1: "99.084%",
    x2: "0%",
    y1: "99.084%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--colors-brand-soft)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--colors-brand)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "radar_svg__b",
    x1: "99.084%",
    x2: "0%",
    y1: "75.528%",
    y2: "23.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--colors-brand-soft)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--colors-brand)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "radar_svg__c",
    x1: "99.084%",
    x2: "0%",
    y1: "76.119%",
    y2: "23.394%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--colors-brand-soft)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--colors-brand)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#radar_svg__a)",
    d: "M98.214 101.717 92.58 93.73l12.018-12.016 7.987 5.633-14.37 14.37zM79.8 75.618l6.683-6.683 13.323 9.398L89.2 88.938l-9.4-13.32zm-17.67-8.127L52.734 58.1l16.23-16.231 9.394 9.392-16.23 16.231zm-12.09 12.09-.014.013a6.651 6.651 0 0 1-9.38-.013 6.652 6.652 0 0 1 0-9.393c.013-.012.024-.022.034-.034l7.97-7.97 9.394 9.393-8.005 8.004zm33.047-51.835.038-.035c2.587-2.59 6.803-2.59 9.393 0a6.6 6.6 0 0 1 1.942 4.696c0 1.773-.69 3.442-1.942 4.696L82.444 47.175l-9.393-9.393 10.035-10.036zM44.608 40.424l-13.32-9.397L41.895 20.42l9.397 13.321-6.683 6.682zM18.509 22.011 32.88 7.642l5.632 7.988-12.014 12.016-7.988-5.635zM119.93 86.72a2.882 2.882 0 0 0-1.211-2.114l-30.89-21.794a2.89 2.89 0 0 0-3.708.318l-3.02 3.019-4.728-4.73L96.6 41.189h.003a12.336 12.336 0 0 0 3.635-8.781c0-3.318-1.29-6.436-3.638-8.782-4.827-4.828-12.678-4.842-17.521-.04-.014.012-.027.026-.041.04l-20.23 20.23-4.728-4.729 3.017-3.02a2.887 2.887 0 0 0 .318-3.707L35.62 1.51a2.884 2.884 0 0 0-4.402-.379l-19.221 19.22a2.886 2.886 0 0 0-.833 2.29 2.885 2.885 0 0 0 1.212 2.114l30.89 21.794a2.887 2.887 0 0 0 3.707-.318l3.02-3.019 4.728 4.728-8.113 8.114-.004.002v.002L36.56 66.102c-.01.013-.024.026-.038.04-4.802 4.845-4.788 12.695.038 17.524a12.387 12.387 0 0 0 8.783 3.633 12.394 12.394 0 0 0 8.782-3.633l.017-.017 18.142-18.144 4.73 4.729-3.017 3.018a2.883 2.883 0 0 0-.317 3.708l21.79 30.891a2.892 2.892 0 0 0 2.363 1.222c.764 0 1.498-.3 2.044-.843l19.22-19.22c.602-.605.909-1.44.834-2.29z",
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#radar_svg__b)",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M12.989 84.793c3.5 5.69 7.836 10.422 13.008 14.195 5.317 3.878 11.76 6.92 19.33 9.127",
    transform: "rotate(1 30.158 211.043)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#radar_svg__c)",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M1 87c3.976 9.3 9.658 16.646 17.045 22.034 7.388 5.39 16.949 9.164 28.684 11.324",
    transform: "rotate(1 24.865 218.268)"
  }))));
};
export default SvgRadar;